import logoSingaporeBusinessFederation from "@assets/events-awards/e50/logo-singapore-business-federation.png";
import logoEnterpriseSingapore from "@assets/events-awards/logo-enterprise-singapore.png";
import logoOCBC from "@assets/events-awards/logo-ocbc.png";
import logoKPMG from "@assets/events-awards/sca/logo-kpmg.png";
import logoSGX from "@assets/events-awards/sca/logo-sgx.png";
import logoBT from "@assets/logo-masthead.svg";
import Container from "@components/Container/Container";

/**
 * Component to render Organiser Details of E50 on homepage
 */
const E50OrganiserDetails = (): React.ReactElement => {
  return (
    <Container>
      <div className="flex flex-col justify-center px-3 pb-15 pt-8 font-public-sans md:px-6 lg:flex-row lg:items-start lg:px-0 lg:px-14 lg:pb-12 lg:pt-12">
        <div className="flex flex-col items-center lg:w-1/3">
          <p>Co-organised By</p>

          <img
            src={logoBT}
            width={300}
            height={55}
            alt="The Business Times logo"
            className="my-6"
          />

          <img
            src={logoKPMG}
            width={120}
            height={20}
            alt="KPMG logo"
            className="mb-14 mt-8 h-[45px] lg:my-6"
          />
        </div>

        <div className="flex flex-col items-center lg:w-1/3">
          <p>Sponsored by</p>

          <img
            src={logoOCBC}
            width={140}
            height={40}
            alt="OCBC logo"
            className="mb-10 mt-8 lg:mt-2"
          />
        </div>

        <div className="flex flex-col items-center lg:w-1/3">
          <p>Supported By</p>

          <img
            src={logoEnterpriseSingapore}
            width={132}
            height={47}
            alt="Enterprice Singapore logo"
            className="mb-14 mt-8 lg:my-6"
          />

          <img
            src={logoSingaporeBusinessFederation}
            width={90}
            height={30}
            alt="Singapore Business Federation logo"
            className="lg:my-6"
          />

          <img
            src={logoSGX}
            width={160}
            height={30}
            alt="SGX logo"
            className="mt-14 lg:my-6"
          />
        </div>
      </div>
    </Container>
  );
};

export default E50OrganiserDetails;
